import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'base.rpc.properties-entities';
export const PropertiesEntitiesApi = NormalizeApi({
  view: `${BASE_ENDPOINT}.view`,
  list: `${BASE_ENDPOINT}.index`,
  create: `${BASE_ENDPOINT}.create`,
  update: `${BASE_ENDPOINT}.update`,
  delete: `${BASE_ENDPOINT}.delete`
});